import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { useState } from "react";
import HeaderBar from "./component/HeaderBar";
import {
  Place,
  Reason,
  Practitioner,
  Plannar,
  Confirm,
  Result,
  BadRequest,
  Annulation
} from "./page";
import { titles } from "./asset/data";
import PageStepper from "./component/Stepper";

function App() {
  const [page, setPage] = useState({
    page: 0,
    place: null,
    motif: null,
    praticien: null,
    date: "",
    dateTo: "",
    patient: {
      nom: "",
      prenom: "",
      email: "",
      tel: "",
    },
    smsConfirmation: false,
    valid: false,
    smsGuid: "",
  });

  return (
    <div
      className="App"
      // Si le media est un mobile on applique une marge en bas de 50px
      // pour compensser la hauteur du 'MobileStepper'.
      style={{
        marginBottom: window.matchMedia("(min-width: 768px)").matches
          ? ""
          : "50px",
      }}
    >
      <HeaderBar title={titles[page.page]} page={page} setPage={setPage} />
      <PageStepper currentPageNo={page.page} page={page} setPage={setPage} />
      {page.page === 0 && <Place setPage={setPage} page={page} />}
      {page.page === 1 && <Reason setPage={setPage} page={page} />}
      {page.page === 2 && <Practitioner setPage={setPage} page={page} />}
      {page.page === 3 && <Plannar setPage={setPage} page={page} />}
      {page.page === 4 && <Confirm setPage={setPage} page={page} />}
      {page.page === 5 && <Result setPage={setPage} page={page} />}
      {page.page === 6 && <BadRequest setPage={setPage} page={page} />}
      {page.page === 7 && <Annulation setPage={setPage} page={page} />}
    </div>
  );
}

export default App;
